module.exports = __webpack_public_path__ + "img/ph_manange4.65c45ab2.png";